import React, { useContext, useEffect, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core";
import DestinationCard from "./DestinationCard";
import { store } from "../util/store";
import { Pagination, PaginationItem } from "@material-ui/lab";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "100%",
    height: "100%",
    overflow: "auto",
    backgroundColor: "white",
    width: "100%",
  },
  cards: {
    flex: "1",
    overflow: "auto",
  },
  ul: {
    justifyContent: "center",
    paddingTop: "10px",
    boxShadow: "0px 5px 7px #000000bd",
    paddingBottom: "10px",
  },
  boxShadow: {
    boxShadow: "0px 2px 3px #00000017",
    border: "1px solid #d3d3d36b",
  },
});

const DestinationsPanel = (props) => {
  const { markers, map } = props;
  const { state } = useContext(store);
  const classes = useStyles({ size: state.screenSize });
  const [currentPage, setCurrentPage] = useState(1);
  const filteredMarkers = markers.filter((marker) => marker.display === true);
  const topAnchorRef = useRef(null);
  const bottomAnchorRef = useRef(null);
  const containerRef = useRef(null);

  // eslint-disable-next-line no-unused-vars
  const [rerender, forceRerender] = useState(0);
  useEffect(() => {
    setCurrentPage(1);
    forceRerender(Math.random());
  }, [state.searchTerm, state.typeFilter, state.countryFilter]);

  const handlePageChange = (event, value) => {
    topAnchorRef && topAnchorRef.current.scrollIntoView();
    setCurrentPage(value);
  };

  useEffect(() => {}, []);

  const pageRenderer = (item) => (
    <PaginationItem
      {...item}
      className={
        item.type === "next" || item.type === "previous"
          ? classes.boxShadow
          : undefined
      }
    />
  );

  const paginate = (array, size, pageNumber) => {
    return array.slice((pageNumber - 1) * size, pageNumber * size);
  };

  const cards = paginate(filteredMarkers, 25, currentPage);

  return (
    <div className={classes.root}>
      <div className={classes.cards} ref={containerRef}>
        <div id="topAnchor" ref={topAnchorRef} />
        {!cards || (cards.length === 0 && <span>No results found</span>)}
        {cards.map((card, index) => (
          <DestinationCard
            destination={card.location}
            googleMarker={card.googleMarker}
            map={map}
            key={index}
          />
        ))}
        {/* when this span is visible in the viewport, it means the user has
        scrolled to the bottom of the results and we can then show the footer */}
        <div id="bottomAnchor" ref={bottomAnchorRef} />
      </div>
      {filteredMarkers.length > 25 && (
        <Pagination
          count={Math.ceil(filteredMarkers.length / 25)}
          page={currentPage}
          onChange={handlePageChange}
          variant="text"
          classes={{ ul: classes.ul }}
          renderItem={pageRenderer}
        />
      )}
    </div>
  );
};

export default DestinationsPanel;
